import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { CookiesService } from '../cookie.service';
import { CookieSettings } from './cookie.types';

@Component({
  selector: 'app-cookie-settings-modal-component',
  templateUrl: './cookie-settings-modal.component.html',
  styleUrls: ['./cookie-settings-modal.component.scss'],
})
export class CookieSettingsModalComponent implements OnInit {
  cookiesSettingsParagraphs: any[];
  cookieSettings: CookieSettings;
  visibleSettings = {
    necessary: false,
    preference: false,
    statistic: false,
    marketing: false,
  };

  private readonly cookiesSettingsParagraphsTranslationKey =
    'COOKIESSETTINGSPAGE.PARAGRAPHS';

  constructor(
    private translate: TranslateService,
    public modal: NgbActiveModal,
    private cookiesService: CookiesService
  ) {}

  ngOnInit() {
    const cookiesSettingsParagraphs = this.translate.instant(
      this.cookiesSettingsParagraphsTranslationKey
    );
    if (
      cookiesSettingsParagraphs !== this.cookiesSettingsParagraphsTranslationKey
    ) {
      this.cookiesSettingsParagraphs = cookiesSettingsParagraphs;
    }
    this.cookieSettings = this.cookiesService.getCookieSettings();
  }

  closeModal() {
    this.modal.dismiss();
  }

  saveCookieSettings() {
    this.modal.close(this.cookieSettings);
  }

  checkboxClicked(settingName: string) {
    this.cookieSettings[settingName] = this.cookieSettings[settingName] =
      this.cookieSettings[settingName] === 0 ? 1 : 0;
  }
}
